export enum DisplayAdUnitCode {
    display = "display",
    midPageUnit = "midPageUnit",
    publisherDefinedMidPageUnit = "publisherDefinedMidPageUnit"
}
